import { useState } from "react";
import { T, TYPE_ICONS } from "../constants";
import TypeBadge from "../shared/TypeBadge";
import PropPill from "../shared/PropPill";

export default function RemedyCard({ item, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={() => onClick(item)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? T.linen2 : T.linen,
        padding: "1.1rem 1.15rem",
        cursor: "pointer",
        transition: "background 0.15s",
        display: "flex", flexDirection: "column",
      }}
    >
      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "flex-start", marginBottom: "7px",
      }}>
        <span style={{ fontSize: "1.4rem" }}>{TYPE_ICONS[item.type] || "🌿"}</span>
        <TypeBadge type={item.type} />
      </div>

      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "1.1rem", fontWeight: 500,
        color: T.bark, lineHeight: 1.2, marginBottom: "6px",
      }}>
        {item.name}
      </div>

      <div style={{
        fontSize: "0.8rem", color: T.muted,
        lineHeight: 1.55, marginBottom: "8px",
      }}>
        {item.description}
      </div>

      <div style={{ height: "0.5px", background: T.linen3, margin: "0 0 8px" }} />

      <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginBottom: "7px" }}>
        {item.properties.slice(0, 3).map(p => <PropPill key={p} label={p} />)}
        {item.properties.length > 3 && (
          <span style={{ fontSize: "0.72rem", color: T.muted, padding: "2px 4px" }}>
            +{item.properties.length - 3}
          </span>
        )}
      </div>
    </div>
  );
}
